// extracted by mini-css-extract-plugin
export default {"container":"EmailDrawerContent_container__GYFJZ","section":"EmailDrawerContent_section__14k2w","form":"EmailDrawerContent_form__1hTCh"};